var level3Task1 = `
<xml xmlns="https://developers.google.com/blockly/xml" id="workspaceBlocks" style="display: none">
  <variables>
    <variable id="4yoW{Za+JKtuGPE|$-)}">list</variable>
  </variables>
  <block type="variables_set" id="OGYu292u2NTiya[STlj|" x="13" y="13">
    <field name="VAR" id="4yoW{Za+JKtuGPE|$-)}">list</field>
    <value name="VALUE">
      <block type="lists_create_with" id="]GfA.UjuEQ9K{4J;4.![">
        <mutation items="5"></mutation>
        <value name="ADD0">
          <block type="math_number" id="RVW;.jvj_9Ka@I{,;T_">
            <field name="NUM">1</field>
          </block>
        </value>
        <value name="ADD1">
          <block type="math_number" id="Yg,Oj_63SMp*8bx%YVc{">
            <field name="NUM">3</field>
          </block>
        </value>
        <value name="ADD2">
          <block type="math_number" id="kc5/ooXP~|@e}9Mf,Wkq">
            <field name="NUM">5</field>
          </block>
        </value>
        <value name="ADD3">
          <block type="math_number" id="Mao||p35u:oZCU,UdeVm">
            <field name="NUM">7</field>
          </block>
        </value>
        <value name="ADD4">
          <block type="math_number" id="mi,^uCwRuk)[GZ*|2?Lx">
            <field name="NUM">9</field>
          </block>
        </value>
      </block>
    </value>
  </block>
  <block type="text_print" id="IB5lf6MfTB(^0~P||bS(" x="12" y="213">
    <value name="TEXT">
      <block type="lists_getIndex" id="}8f(:xxl|W=:Tyi4AdoQ">
        <mutation statement="false" at="true"></mutation>
        <field name="MODE">GET</field>
        <field name="WHERE">FROM_START</field>
        <value name="VALUE">
          <block type="variables_get" id="?(1E~ESnH--_dm+z@5Us">
            <field name="VAR" id="4yoW{Za+JKtuGPE|$-)}">list</field>
          </block>
        </value>
        <value name="AT">
          <block type="math_number" id="pph;L/p7O=5Sq5@5SOW;">
            <field name="NUM">3</field>
          </block>
        </value>
      </block>
    </value>
  </block>
</xml>
`
export default level3Task1